export default {
  path: '/servico-av/:id',
  component: () => import('@/components/pages/AVServices/AVService')
}
